import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetClassTrainer(club) {

  var url = "/class_app/" + club + "/admin/all_class_trainers";

  return FetchGetDataWithAuthNEW(url);
}

